/**
 * Modal — todas las revistas (página Egresados).
 */
export function marianistaInitEgRevistasModal() {
  const modal = document.getElementById('eg-revistas-modal');
  if (!modal) {
    return;
  }

  const backdrop = document.getElementById('eg-revistas-modal-backdrop');
  const closeBtn = document.getElementById('eg-revistas-modal-close');

  const openModal = () => {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    closeBtn instanceof HTMLElement && window.setTimeout(() => closeBtn.focus(), 60);
  };

  const closeModal = () => {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element
      ? event.target.closest('[data-open-revistas-modal]')
      : null;
    if (trigger) {
      openModal();
    }
  });

  backdrop?.addEventListener('click', closeModal);
  closeBtn?.addEventListener('click', closeModal);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });
}
